import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import { fetchAnimationData } from '../utils/cloudflareR2';

const FeaturedProjects = () => {
  return (
    <div className="featured-projects-container">
      {/* Project 1 - ASIDE */}
      <div className="featured-project">
        <div className="featured-project-lottie">
          <CloudflareLottie
            animationName="aside"
            loop={true}
            autoplay={true}
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid slice'
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
        </div>
        <div className="featured-project-info">
          <div className="project-client">
            <p><span>Project:</span> Aside, Actor's audition self tape tool, powered by AI</p>
          </div>
          <div className="project-deliverables">
            <p><span>Deliverables:</span> 0-1 Product Strategy, MVP published in the App Store</p>
          </div>
        </div>
      </div>
      
      {/* Project 2 - CSABA */}
      <div className="featured-project">
        <div className="featured-project-lottie">
          <CloudflareLottie
            animationName="csaba"
            loop={true}
            autoplay={true}
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid slice'
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
        </div>
        <div className="featured-project-info">
          <div className="project-client">
            <p><span>Project:</span> Csaba AI Coach</p>
          </div>
          <div className="project-deliverables">
            <p><span>Deliverables:</span> 0-1 Product Strategy, MVP Prototypes for Fundraising</p>
          </div>
        </div>
      </div>
      
      {/* Project 3 - FindAI */}
      <div className="featured-project">
        <div className="featured-project-lottie">
          <CloudflareLottie
            animationName="findAI"
            loop={true}
            autoplay={true}
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid slice'
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
        </div>
        <div className="featured-project-info">
          <div className="project-client">
            <p><span>Project:</span> FindAI</p>
          </div>
          <div className="project-deliverables">
            <p><span>Deliverables:</span> Responsive UI Reskin, Tactical Features</p>
          </div>
        </div>
      </div>
      
      {/* Project 4 - SOS */}
      <div className="featured-project">
        <div className="featured-project-lottie">
          <CloudflareLottie
            animationName="sos"
            loop={true}
            autoplay={true}
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid slice'
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
        </div>
        <div className="featured-project-info">
          <div className="project-client">
            <p><span>Project:</span> SOS Rescue Crisis Management</p>
          </div>
          <div className="project-deliverables">
            <p><span>Deliverables:</span> 0-1 Product Development, Operational Dashboards for 12 Technical Users</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// CloudflareLottie component to handle loading animations from R2
const CloudflareLottie = ({ animationName, ...props }) => {
  const [animationData, setAnimationData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const loadAnimation = async () => {
      try {
        console.log(`[Lottie] Starting to load animation: ${animationName}`);
        setIsLoading(true);
        const data = await fetchAnimationData(animationName);
        console.log(`[Lottie] Received data for ${animationName}:`, data ? 'Data received' : 'No data');
        
        if (isMounted) {
          if (data) {
            setAnimationData(data);
            setError(null);
          } else {
            const error = new Error('No data returned from fetchAnimationData');
            error.type = 'NO_DATA';
            throw error;
          }
        }
      } catch (err) {
        console.error(`[Lottie] Error in loadAnimation for ${animationName}:`, {
          name: err.name,
          message: err.message,
          type: err.type,
          status: err.status,
          stack: err.stack
        });
        
        if (isMounted) {
          setError({
            message: `Failed to load animation: ${err.message}`,
            type: err.type || 'UNKNOWN_ERROR',
            status: err.status,
            details: err
          });
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadAnimation();

    return () => {
      isMounted = false;
    };
  }, [animationName]);

  // Log state changes
  useEffect(() => {
    if (isLoading) {
      console.log(`[Lottie] ${animationName} is loading`);
    } else if (error) {
      console.error(`[Lottie] ${animationName} error:`, error);
    } else if (animationData) {
      console.log(`[Lottie] ${animationName} loaded successfully`);
    }
  }, [animationName, isLoading, error, animationData]);

  if (isLoading) {
    return (
      <div className="lottie-loading" style={{ 
        border: '1px solid #ccc', 
        padding: '10px', 
        margin: '10px 0',
        borderRadius: '4px',
        backgroundColor: '#f8f9fa',
        color: '#666',
        textAlign: 'center'
      }}>
        Loading {animationName}...
      </div>
    );
  }

  if (error) {
    return (
      <div className="lottie-error" style={{ 
        border: '1px solid #ffcdd2', 
        padding: '10px', 
        margin: '10px 0',
        borderRadius: '4px',
        backgroundColor: '#ffebee',
        color: '#c62828',
        textAlign: 'left',
        maxWidth: '100%',
        overflow: 'auto'
      }}>
        <div><strong>Error loading {animationName}:</strong> {error.message}</div>
        {error.status && <div>Status: {error.status} {error.statusText || ''}</div>}
        {error.type && <div>Type: {error.type}</div>}
        <details style={{ marginTop: '8px', fontSize: '0.9em' }}>
          <summary>Technical details</summary>
          <pre style={{ 
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word',
            fontFamily: 'monospace',
            margin: '8px 0 0 0',
            padding: '8px',
            backgroundColor: 'rgba(0,0,0,0.05)',
            borderRadius: '4px'
          }}>
            {JSON.stringify(error.details || {}, null, 2)}
          </pre>
        </details>
      </div>
    );
  }

  if (!animationData) {
    return (
      <div className="lottie-no-data" style={{ 
        border: '1px solid #ffb74d', 
        padding: '10px', 
        margin: '10px 0',
        borderRadius: '4px',
        backgroundColor: '#fff3e0',
        color: '#e65100',
        textAlign: 'center'
      }}>
        No animation data available for {animationName}
      </div>
    );
  }

  console.log(`[Lottie] Rendering ${animationName} with data:`, {
    hasAnimationData: !!animationData,
    layers: animationData?.layers?.length,
    frames: animationData?.op,
    width: animationData?.w,
    height: animationData?.h
  });

  try {
    return (
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Lottie 
          animationData={animationData} 
          loop={true}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet',
            progressiveLoad: true
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      </div>
    );
  } catch (renderError) {
    console.error(`[Lottie] Error rendering ${animationName}:`, renderError);
    return (
      <div className="lottie-render-error" style={{ 
        border: '1px solid #f44336', 
        padding: '10px', 
        margin: '10px 0',
        borderRadius: '4px',
        backgroundColor: '#ffebee',
        color: '#b71c1c',
        textAlign: 'left',
        maxWidth: '100%',
        overflow: 'auto'
      }}>
        <div><strong>Failed to render animation {animationName}:</strong> {renderError.message}</div>
        <pre style={{ 
          whiteSpace: 'pre-wrap', 
          wordBreak: 'break-word',
          fontFamily: 'monospace',
          margin: '8px 0 0 0',
          padding: '8px',
          backgroundColor: 'rgba(0,0,0,0.05)',
          borderRadius: '4px',
          fontSize: '0.8em'
        }}>
          {renderError.stack}
        </pre>
      </div>
    );
  }
};

export default FeaturedProjects;
